import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Order } from '../../../shared/classes/order';
import { OrderService } from '../../../shared/services/order.service';
import { ProductService } from '../../../shared/services/product.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit, AfterViewInit{

  // public orderDetails : Order = {};
  profile: any;
  orderDetails: any;
  isGuest: boolean = true; // Set to true or false based on user status
  isLoading: boolean = true;

  constructor(public productService: ProductService,
    private orderService: OrderService,
    private _acountService: AccountService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const orderId = Number(params.get('id'));
      this.profile = JSON.parse(localStorage.getItem('user') || 'null');

      if (orderId) {
        this.getOrderDetails(orderId); // Fetch the order details
      } else {
        this.isLoading = false;
        this.toastr.error('Invalid order ID'); // Show an error if the order_id is invalid
      }
    });
  }

  getOrderDetails(orderId: number): void {
    this.isLoading = true;
    // Determine if the user is a guest or logged in
    const customerId = this.profile?.id;
    const guestId = this.isGuest ? Number(localStorage.getItem('guest_id')) : null;

    // Call the service method
    this.orderService.getOrderDetails(orderId, this.isGuest, customerId, guestId).subscribe({
      next: (response) => {
        this.orderDetails = response;
        this.isLoading = false;
        console.log('Order details:', response);
      },
      error: (error) => {
        console.error('Error fetching order details:', error);
        this.isLoading = false;
        this.toastr.error('Failed to fetch order details');
      }
    });
  }

  download() {
    this._acountService.downloadRequestFile(this.orderDetails.order_id).subscribe({
        next: (blob: Blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = this.orderDetails.order_id;
            a.click();
            window.URL.revokeObjectURL(url);
        },
        error: (err) => {
            this.toastr.error('The requested file was not found.', 'Not found')
        },
    });
}

  ngAfterViewInit() {

  }

}
